import { createFileRoute } from "@tanstack/react-router"

import { LegalVersionPage } from "@/components/content/legal-version-page"
import {
  currentLegalVersion,
  lazyLegalModules,
  loadCurrentLegalVersion,
  resolveLegalVersions,
} from "@/lib/legal-versions"
import { seoMeta } from "@/lib/seo"

const modules = lazyLegalModules(import.meta.glob("../-content/privacy/*.md"))

export const Route = createFileRoute("/_content/privacy/")({
  head: () =>
    seoMeta({
      title: "Privacy Policy",
      description: "How Entire collects, uses, and protects your personal information.",
      url: "https://entire.com/privacy",
      image: "https://entire.com/og/page/privacy.png",
    }),
  loader: () => loadCurrentLegalVersion(modules),
  component: PrivacyPage,
})

function PrivacyPage() {
  const { asOf } = Route.useLoaderData()
  const versions = resolveLegalVersions(modules, asOf)
  const current = currentLegalVersion(versions)!
  return <LegalVersionPage basePath="/privacy" version={current} versions={versions} />
}
